// src/private/ColorGrid.js
// Reusable color-grid swatch picker: one row per base color, each expanded
// into its base shade plus 4 lighter tints (see colorPalette.js). Shared by
// the scenario connector color menu and the sticky-note color pickers.
import React from "react";
import { withTints } from "./colorPalette";
import { useT } from "../i18n/langContext";
import "./ColorGrid.css";

export default function ColorGrid({ colors, value, onPick, allowNone = false, noneLabel }) {
  const t = useT();
  const resolvedNoneLabel = noneLabel || t('canvas.colorGrid.noneLabel');
  const grid = withTints(colors);
  return (
    <div className="color-grid">
      {allowNone && (
        <button
          type="button"
          className={`color-grid__swatch color-grid__swatch--none${!value ? " is-active" : ""}`}
          title={resolvedNoneLabel}
          aria-label={resolvedNoneLabel}
          onClick={() => onPick(null)}
        />
      )}
      {grid.map((row) => (
        <div className="color-grid__row" key={row[0]}>
          {row.map((c) => (
            <button
              key={c}
              type="button"
              className={`color-grid__swatch${value === c ? " is-active" : ""}`}
              style={{ background: c }}
              title={c}
              aria-label={t('canvas.colorGrid.colorAria', { color: c })}
              onClick={() => onPick(c)}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
